import React, { FC, useState } from 'react';
import { Button, Container, Table } from 'react-bootstrap';
import { playerDeletionResult, useDeletionRequests } from './use-deletion-requests';
import { observer } from 'mobx-react-lite';
import { CustomSpinner } from '@yakoffice/custom-spinner';
import { DeletionStatusMap } from './deletion-status-controller';
import { IDeleteUserController, useDeleteUserController } from './use-delete-user-controller';
import { YoGameEnvironmentRoles } from '../../config/yo-game-environment-roles';
import { useAuthUser } from '@yakoffice/yakoffice-firebase';
import { useNavigate, useParams } from 'react-router-dom';
import styles from '../data-source/dataSource.module.sass';
import { NoAccess } from '@yakoffice/shared-components';
import { CreateItemRoute } from '../../routes/PlayersRoutes';
import { PlayersHeader } from '../players-header/players-header';
import Alert from 'react-bootstrap/Alert';


export const DeletionRequests: FC = observer(() => {

    const authUser = useAuthUser();
    const { projectId, gameEnvironmentId } = useParams() as {
        projectId: string,
        gameEnvironmentId: string
    };

    const playerDeletionRequestsResult = useDeletionRequests();
    const deleteUserController = useDeleteUserController();
    const navigate = useNavigate();

    const [playerId, setPlayerId] = useState('');

    const handleGameEnvironmentChange = (gameEnvironmentId: string) => {
        navigate(CreateItemRoute(projectId, gameEnvironmentId.toLowerCase(), 'player', 'deletion-requests'));
    };

    const renderDeletionRequests = () => {

        if (playerDeletionRequestsResult.deletionRequests && playerDeletionRequestsResult.deletionRequests.length > 0) {

            if (playerId === '')
                return playerDeletionRequestsResult.deletionRequests.map(deletionResult => PlayerDeletions(deletionResult, deleteUserController));

            else
                return playerDeletionRequestsResult.deletionRequests.filter(deletionRequests => deletionRequests.id.includes(playerId)).map(deletionResult => PlayerDeletions(deletionResult, deleteUserController));
        }
    };

    return (authUser?.hasGameEnvironmentRoleClaim(projectId, gameEnvironmentId, YoGameEnvironmentRoles.ViewPlayers)
            ?
            <div className={`${styles.projectContent} projectContent themed-project`}>
                {playerDeletionRequestsResult.isLoaded ?
                    <>
                        <PlayersHeader handleGameEnvironmentChange={handleGameEnvironmentChange}
                                       handleSearchItem={setPlayerId}
                                       title={'Player Deletion'} />

                        <Container fluid>
                            {playerDeletionRequestsResult.deletionRequests && playerDeletionRequestsResult.deletionRequests?.length > 0 ?
                                <Table className={`${styles.deletionRequestsTable}`}>
                                    <thead>
                                    <tr>
                                        <th>Player Id</th>
                                        <th>Deletion Scope</th>
                                        <th>Deletion Status</th>
                                        <th>Action</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {
                                        renderDeletionRequests()
                                    }
                                    </tbody>
                                </Table>
                                :
                                <Alert variant={'info'}>No deletion requests found</Alert>
                            }

                        </Container>
                    </>
                    :
                    <CustomSpinner spinnerText="Loading deletion requests..." />
                }
            </div>
            : <NoAccess />
    );
});

const PlayerDeletions = (playerDeletionResult: playerDeletionResult, deleteUserController: IDeleteUserController) => {


    const DeletionClassMap: { [key: number]: string } =
        {
            2: 'text-danger',
            4: 'text-danger',
            6: 'text-danger',
            7: 'text-danger',
            5: 'text-info',
            8: 'text-success'
        };

    const handleDelete = (playerId: string) => {
        deleteUserController.handleEndUserDeletion(playerId);
    };

    const handleResumeDeletion = (playerId: string) => {
        deleteUserController.handleResumeUserDeletion(playerId);
    };

    const deletionButton = (playerDeletionResult: playerDeletionResult) => {

        switch (playerDeletionResult.status) {

            case 2:
            case 4:
            case 6:
            case 7:
                return <Button className="ml-2" size="sm"
                               onClick={() => handleResumeDeletion(playerDeletionResult.id)}>Resume Deletion</Button>;

            case 5:
                return <Button className="ml-2" size="sm"
                               onClick={() => handleDelete(playerDeletionResult.id)}>Confirm Deletion</Button>;

            default:
                return <div></div>;
        }
    };

    return (
        <tr key={playerDeletionResult.id}>
            <td>{playerDeletionResult.id}</td>
            <td>{playerDeletionResult.deletionScope}</td>
            <td
                className={DeletionClassMap[playerDeletionResult.status]}>{DeletionStatusMap[playerDeletionResult.status]}</td>
            <td>{deletionButton(playerDeletionResult)}</td>
        </tr>
    );
};
